<template>
  <div class="mb-3">
    <v-card outlined>
      <v-card-title>
        فیلتر <v-spacer></v-spacer>
        <v-btn fab dark small color="primary">
          <v-icon large @click="showSetting = !showSetting">
            {{ showSetting ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="showSetting">
        <v-row>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              dense
              label="نام کالا/خدمات"
              v-model="search.SupplierProductName"
              outlined
            ></v-text-field>
          </v-col>
        
        
       
        </v-row>
      </v-card-text>
      <v-card-actions v-if="showSetting">
        <v-spacer></v-spacer>
        <v-btn color="error" @click="clearAll()">
          <span>حذف</span>
        </v-btn>
        <v-btn color="blue" dark @click="searchData()">
          <span>جست و جو</span>
          <v-icon small class="mx-1"> mdi-magnify </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
const enumsRepository = () => RepoFactory.get('enums');
import Helper from '@/core/helpers';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {

  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      showSetting: false,
      search: {
        SupplierProductName: null,
      },
      statusItem: [],
    };
  },

  
  computed: {
    ...mapGetters(['productBaseUrl']),
  },
  methods: {
    clearAll() {
      this.search = {
        SupplierProductName: null,

      };
      this.searchData();
    },
    searchData() {
      this.$emit('selectedDataFunc', this.selected);
    },
 
  },
};
</script>

<style>
</style>